/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { RECEIVE_USER_INFORMATION } from '../Mcq/View/actionTypes';
import { getValidationState } from '../Mcq/View/Selectors';
import { MCQ_VALIDATION_STATE } from '../Mcq/View/constants';
import toc, { FAIL, SUCCESS } from '../services/toc';

const exerciseMiddleware = (store) => (next) => (action) => {
  if (action.type === RECEIVE_USER_INFORMATION) {
    const validationState = getValidationState(action.payload);

    switch (validationState) {
      case MCQ_VALIDATION_STATE.SUCCESSFUL:
        toc.setCurrentItemState(SUCCESS);
        break;
      case MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_NOT_SUBMITABLE:
      case MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_SUBMITABLE:
      case MCQ_VALIDATION_STATE.UNSUCCESSFUL_AND_SUBMITABLE_LATER:
        toc.setCurrentItemState(FAIL);
        break;
    }
  }

  return next(action);
};

export default exerciseMiddleware;
